/** The file was automatically generated. Please do not modify manually */
import el from './online.json';
export var strings_el = el;
